import { BaseMapper } from 'src/data/common/BaseMapper'
import { ParamsMapper } from 'src/data/common/type'

import { CustomerRxAPI, CustomerRxModel } from './type'

export class CustomerRxMapper extends BaseMapper {
  apiMapper = (rx: CustomerRxAPI): CustomerRxModel => {
    return {
      id: rx.id,
      state: rx.state,
      date: rx.date,
      expiration_date: rx.expiration_date,
      image_url: rx.image_url,
      is_cyl_axis_transposed: rx.is_cyl_axis_transposed ?? false,
      os: {
        sph: rx.os_sph,
        cyl: rx.os_cyl,
        axis: rx.os_axis,
        add: rx.os_add,
        prism: rx.rx_os_prism,
        prism2: rx.rx_os_prism2,
        prism_dir: rx.rx_os_prism_dir,
        prism2_dir: rx.rx_os_prism2_dir,
      },
      od: {
        sph: rx.od_sph,
        cyl: rx.od_cyl,
        axis: rx.od_axis,
        add: rx.od_add,
        prism: rx.rx_od_prism,
        prism2: rx.rx_od_prism2,
        prism_dir: rx.rx_od_prism_dir,
        prism2_dir: rx.rx_od_prism2_dir,
      },
    }
  }

  defaultValue: CustomerRxModel = {
    id: 0,
    date: '',
    expiration_date: '',
    state: '',
    image_url: '',
    is_cyl_axis_transposed: false,
    os: {
      sph: 0,
      cyl: 0,
      axis: 0,
      add: 0,
      prism: 0,
      prism2: 0,
      prism_dir: '',
      prism2_dir: '',
    },
    od: {
      sph: 0,
      cyl: 0,
      axis: 0,
      add: 0,
      prism: 0,
      prism2: 0,
      prism_dir: '',
      prism2_dir: '',
    },
  }

  getMappedObject(params: ParamsMapper): any {
    return super.getMappedObject(params)
  }
}
